import request from './request'

/**
 * 产品类型枚举
 * 0:子弹发薪 1:电子签 2:日日保 3:长期保 4:微聘 5:微保 6:团意日保 7:群发消息 8:安心日保 99:保险
 */
export enum ProductType {
    SALARY = 0,         // 子弹发薪
    ELE_SIGN = 1,       // 电子签
    DAILY_INSURE = 2,   // 日日保
    LONG_INSURE = 3,    // 长期保
    WEI_PIN = 4,        // 微聘
    WEI_BAO = 5,        // 微保
    TEAM_DAILY = 6,     // 团意日保
    MESSAGE = 7,        // 群发消息
    AX_DAILY = 8,       // 安心日保
    INSURANCE = 99      // 保险
}

/**
 * 查询是否需要收集签署人信息 - 请求参数
 */
export interface QueryIsCollectHandlerInfoReqDto {
    productType: number
}

/**
 * 查询是否需要收集签署人信息 - 响应参数
 */
export interface QueryIsCollectHandlerInfoResDto {
    /** 天数 */
    days?: number
    /** 是否需要收集 (0:不需要 1:需要) */
    isCollect?: number
}

/**
 * 填写签署人信息 - 请求参数
 */
export interface FillSignersReqDto {
    /** 姓名 */
    name: string
    /** 手机号 */
    phone: string
    /** 产品类型 */
    productType: number
}

/**
 * 查询未签署合同信息 - 请求参数
 */
export interface QueryUnsignedContractReqDto {
    productType: number
}

/**
 * 查询未签署合同信息 - 响应参数
 */
export interface QueryUnsignedContractResDto {
    /** 天数 */
    days?: number
    /** 文件名 */
    fileName?: string
    /** 是否有待签署合同 (0:无 1:有) */
    hasUnsigned?: number
    /** 签署人 */
    signer?: string
    /** 签署链接 */
    url?: string
}

/**
 * 查询是否需要收集签署人信息
 */
export function queryIsCollectHandlerInfo(params: QueryIsCollectHandlerInfoReqDto): Promise<QueryIsCollectHandlerInfoResDto> {
    return request.get('/isNew---/web/pc/pay/esignCustomerSignRecord/queryIsCollectHandlerInfo', { params })
}

/**
 * 填写签署人信息
 */
export function fillSigners(data: FillSignersReqDto): Promise<void> {
    return request.post('/isNew---/web/pc/pay/esignCustomerSignRecord/fillSigners', data)
}

/**
 * 查询未签署合同信息
 */
export function queryUnsignedContract(params: QueryUnsignedContractReqDto): Promise<QueryUnsignedContractResDto> {
    return request.get('/isNew---/web/pc/pay/esignCustomerSignRecord/queryUnsignedContract', { params })
}
